<template>
  <div>
    <ValidationProvider v-slot="{ errors }">
      <b-field
        label="Assets"
        :type="{ 'is-danger': errors.length > 0 }"
        :message="errors[0]"
      >
        <input v-show="false" v-model="file" />
      </b-field>
      <div v-if="items.length === 0">No assets uploaded.</div>
      <div v-if="items.length > 0">
        <ul>
          <li v-for="item in items" :key="item.id">
            <a :href="item.path">{{ item.name }}</a>
            <a href="" class="has-margin-left-5" @click.prevent="remove(item)"
              >Delete</a
            >
          </li>
        </ul>
      </div>
      <b-button
        size="is-small"
        @click="
          showUpload = !showUpload
          showUrlUpload = false
        "
        >{{ showUpload ? 'Hide Upload' : 'From File' }}</b-button
      >
      <b-button
        size="is-small"
        @click="
          showUrlUpload = !showUrlUpload
          showUpload = false
        "
        >{{ showUrlUpload ? 'Hide Upload' : 'From URL' }}</b-button
      >
    </ValidationProvider>
    <div v-if="showUrlUpload">
      <b-field label="Name">
        <b-input v-model="name" />
      </b-field>
      <b-field label="File URL">
        <b-input v-model="uploadUrl" type="url" />
      </b-field>
      <b-button
        :loading="uploadFromUrlLoading"
        @click="uploadFromUrl(uploadUrl)"
        >Upload from URL</b-button
      >
    </div>
    <b-field label="Name" v-if="showUpload">
      <b-input v-model="name" />
    </b-field>
    <b-upload
      v-if="showUpload"
      v-model="fileFile"
      drag-drop
      :loading="showUploadLoading"
      @input="uploadFile"
    >
      <section class="section">
        <div class="content has-text-centered">
          <p>
            <b-icon icon="upload" size="is-large"> </b-icon>
          </p>
          <p>Drop your file here or click to upload</p>
        </div>
      </section>
    </b-upload>
    <b-progress
      v-if="showUploadLoading"
      type="is-info"
      :value="showUploadProgress"
    ></b-progress>
  </div>
</template>

<script>
import UploadApi from '@/api/upload'
import MediaAssetsApi from '@/api/mediaAssets'
import EventBus from '@/eventbus'

export default {
  name: 'UploadMediaAssets',
  inheritAttrs: false,
  props: {
    mediaId: {
      type: Number,
      default: null,
    },
    episodeId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showUpload: false,
      showUrlUpload: false,
      showUploadLoading: false,
      uploadUrl: null,
      uploadFromUrlLoading: false,
      fileFile: null,
      showUploadProgress: 0,
      file: null,
      items: [],
      name: 'Unnamed',
    }
  },
  async created() {
    await this.loadData()
  },
  methods: {
    remove(item) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to delete this item?',
        onConfirm: async () => {
          await MediaAssetsApi.remove(item)
          await this.loadData()
        },
      })
    },
    async loadData() {
      this.items = await MediaAssetsApi.getAll(this.mediaId, this.episodeId)
    },
    uploadFromUrl(url) {
      this.uploadFromUrlLoading = true
      let filename = url.split('/').pop()
      UploadApi.uploadFromUrl(url, filename)
        .then((response) => {
          this.file = response.url
          this.showUrlUpload = false
          this.uploadFromUrlLoading = false
          MediaAssetsApi.create({
            mediaId: this.mediaId,
            episodeId: this.episodeId,
            name: this.name,
            path: response.url,
          }).then(() => {
            return this.loadData()
          })
        })
        .catch((err) => {
          console.log(err)
          this.uploadFromUrlLoading = false
          this.$buefy.toast.open({
            message: `Error uploading from URL`,
            position: 'is-top',
            type: 'is-danger',
          })
        })
    },
    uploadFile(file) {
      this.showUploadLoading = true
      UploadApi.getPresignedLink({ file: file.name, bucket: 'assets' })
        .then((response) => {
          EventBus.$on(file.name, (progress) => {
            this.showUploadProgress = progress
          })
          UploadApi.uploadToS3(response, file)
            .then(() => {
              this.file = response.final
              this.showUpload = false
              this.showUploadLoading = false
              EventBus.$off(file.name)
              MediaAssetsApi.create({
                mediaId: this.mediaId,
                episodeId: this.episodeId,
                name: this.name,
                path: response.final,
              }).then(() => {
                return this.loadData()
              })
            })
            .catch((err) => {
              console.log(err)
              this.$buefy.toast.open({
                message: `Error uploading ${this.label} (2)`,
                position: 'is-top',
                type: 'is-danger',
              })
              this.showUploadLoading = false
            })
        })
        .catch((err) => {
          console.log(err)
          this.$buefy.toast.open({
            message: `Error uploading ${this.label} (1)`,
            position: 'is-top',
            type: 'is-danger',
          })
          this.showUploadLoading = false
        })
    },
  },
}
</script>
